import React, { useRef, useState, useEffect, useCallback } from "react";
import './MainBannerComponent.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const popularCities = [
    { iata_code: "DEL", name: "Indira Gandhi International Airport", municipality: "New Delhi", countryName: "India" },
    { iata_code: "BOM", name: "Chhatrapati Shivaji International Airport", municipality: "Mumbai", countryName: "India" },
    { iata_code: "DXB", name: "Dubai International Airport", municipality: "Dubai", countryName: "United Arab Emirates" },
    { iata_code: "NBO", name: "Jomo Kenyatta International Airport", municipality: "Nairobi", countryName: "Kenya" },
    { iata_code: "LHR", name: "Heathrow Airport", municipality: "London", countryName: "United Kingdom" },
    { iata_code: "SIN", name: "Singapore Changi Airport", municipality: "Singapore", countryName: "Singapore" },
    { iata_code: "JFK", name: "John F. Kennedy International Airport", municipality: "New York", countryName: "United States" },
    { iata_code: "HKG", name: "Hong Kong International Airport", municipality: "Hong Kong", countryName: "Hong Kong" },
    { iata_code: "LAX", name: "Los Angeles International Airport", municipality: "Los Angeles", countryName: "United States" },
    { iata_code: "CDG", name: "Charles de Gaulle Airport", municipality: "Paris", countryName: "France" },
];

const MainBannerComponent = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };
    const dropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const datePickerRef = useRef(null);
    const datepickerRef = useRef(null);
    const datePickerRef2 = useRef(null);
    const datePickerRef3 = useRef(null);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const urlToken = params.get("token");

    useEffect(() => {
        if (urlToken) {
            localStorage.setItem("bearerToken", urlToken);
            window.location.href = '/home';
        }
    }, [urlToken]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (location.state?.showModal) {
            setShowModal(false);
        }
    }, [location.state]);
    console.log(showModal)

    const bearerToken = localStorage.getItem('bearerToken');
    if (bearerToken === '' || bearerToken === undefined || bearerToken === null)
        window.location.href = '/login';
    const navigate = useNavigate();
    const loadSearchCriteria = () => {
        const savedCriteria = localStorage.getItem("searchCriteria");
        return savedCriteria ? JSON.parse(savedCriteria) : {};
    };
    // const [searchDatas, setSearchDatas] = useState(loadSearchCriteria());
    // const queryP = searchDatas;
    // const queryParams = queryP.split('&');

    // const searchData = {
    //     origin: queryParams.replace("origin=", "") || "",
    //     destination: queryParams.replace("destination", "") || "",
    //     fromdate: queryParams.replace("fromdate", "") ? new Date(queryParams.replace("fromdate=", "")) : new Date(),
    //     adult: parseInt(queryParams.replace("adult=", "")) || 1,
    //     child: parseInt(queryParams.replace("child=", "")) || 0,
    //     infant: parseInt(queryParams.replace("infant=", "")) || 0,
    //     isRound: queryParams.replace("isRound=", "") === "1",
    //     fareType: queryParams.replace("fareType=", "") || "RC",
    //     currency: queryParams.replace("currency=", "") || "INR",
    //     fullDepart: queryParams.replace("fulldepart=", "") || "",
    //     fullDesti: queryParams.replace("fulldesti=", "") || "",
    //     isRF: queryParams.replace("isRF=", "") || 0,
    // };
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        return d;
    });
    const [returnDate, setReturnDate] = useState();
    const [tripType, setTripType] = useState("1");
    const [showTravelerModal, setShowTravelerModal] = useState(false);
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [cabinClass, setCabinClass] = useState("Y");
    const [cabinClassText, setCabinClassText] = useState("Economy");
    const [fareType, setFareType] = useState("RC");
    const [currency, setCurrency] = useState("INR");
    const [isNRF, setIsNRF] = useState("0");

    const [loading, setLoading] = useState(false); // Loader state

    const handleTravelerModalToggle = () => {
        setShowTravelerModal(!showTravelerModal);
    };

    const handleTripTypeChange = (type) => {
        setTripType(type);

        if (type !== '2') setReturnDate();
        else setReturnDate(new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000));
        if (type === '2') setReturnDate(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
    };

    const [departure, setDeparture] = useState('DEL, Indira Gandhi International Airport, New Delhi');
    const [departureOptions, setDepartureOptions] = useState(popularCities);
    const [departureIataCode, setDepartureIataCode] = useState('DEL');

    const [destination, setDestination] = useState('BOM, Chhatrapati Shivaji International Airport, Mumbai');
    const [destinationOptions, setDestinationOptions] = useState(popularCities);
    const [destinationIataCode, setDestinationIataCode] = useState('BOM');
    const [showDestinationDropdown, setShowDestinationDropdown] = useState(false);

    const [depart2, setDepart2] = useState(new Date());
    const [depart3, setDepart3] = useState(new Date());
    const [from2, setFrom2] = useState('');
    const [to2, setTo2] = useState('');
    const [to2IataCode, setTo2IataCode] = useState('');
    const [from2IataCode, setFrom2IataCode] = useState('');
    const [from3, setFrom3] = useState('');
    const [from3IataCode, setFrom3IataCode] = useState('');
    const [to3, setTo3] = useState('');
    const [to3IataCode, setTo3IataCode] = useState('');
    const [from2Options, setFrom2Options] = useState([]);
    const [to2Options, setTo2Options] = useState([]);
    const [from3Options, setFrom3Options] = useState([]);
    const [to3Options, setTo3Options] = useState([]);
    const [showFrom2Dropdown, setShowFrom2Dropdown] = useState(false);
    const [showTo2Dropdown, setShowTo2Dropdown] = useState(false);
    const [showFrom3Dropdown, setShowFrom3Dropdown] = useState(false);
    const [showTo3Dropdown, setShowTo3Dropdown] = useState(false);
    const [recent, setRecent] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [activeDestinationIndex, setActiveDestinationIndex] = useState(-1);
    const [index, setIndex] = useState();
    const [tooltip, setTooltip] = useState("");

    const [hoveredIndex, setHoveredIndex] = useState(-1);
    const [isKeyboardActive, setIsKeyboardActive] = useState(false);


    const inputRefs = {
        from: useRef(null),
        to: useRef(null),
        from2: useRef(null),
        to2: useRef(null),
        from3: useRef(null),
        to3: useRef(null),
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !Object.values(inputRefs).some(ref => ref.current && ref.current.contains(event.target))
            ) {
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                handleDropdownClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const fareTypeoptions = [
        { value: "RC", label: "REGULAR FARES", description: "Standard fare for regular passengers." },
        { value: "STC", label: "STUDENT FARES", description: "Applicable only for students above 12 years of age. Valid student ID cards and student visas (where applicable) are required to avail this." },
        { value: "YCD", label: "SENIOR CITIZEN", description: "Applicable only for senior citizens above the age of 60 years. A valid proof of Date of Birth is required at the airport to avail this." },
    ];

    const [firstClass, setFirstClass] = useState(true);
    const [businessClass, setBusinessClass] = useState(true);
    const [economyClass, setEconomyClass] = useState(true);
    const [premiumEcoClass, setPremiumEcoClass] = useState(true);

    const [isAddPay, setIsAddPay] = useState(true);
    const [isForFamily, setIsForFamily] = useState(true);
    const [isPersonalTravel, setIsPersonalTravel] = useState(true);
    const [walletAmount, setWalletAmount] = useState(0);
    const policy = JSON.parse(sessionStorage.getItem('policies'));
    useEffect(() => {
        if (policy !== null) {
            if (policy[0].policy !== null) {
                setFirstClass(policy[0].policy.firstClass);
                setBusinessClass(policy[0].policy.businessClass);
                setEconomyClass(policy[0].policy.economyClass);
                setPremiumEcoClass(policy[0].policy.premiumEcoClass);
            }
            else {
                setFirstClass(true);
                setBusinessClass(true);
                setEconomyClass(true);
                setPremiumEcoClass(true);
            }
            if (policy[0].user !== null) {
                setIsAddPay(policy[0].user.isAddPay);
                setIsForFamily(policy[0].user.isForFamily);
                setIsPersonalTravel(policy[0].user.isPersonalTravel);
                setWalletAmount(policy[0].user.walletAmount);
            }
            if (policy[0].user.policyId === 0) {
                setIsAddPay(true);
                setIsForFamily(true);
                setIsPersonalTravel(false);
                setWalletAmount(1000000000);
                setFirstClass(true);
                setBusinessClass(true);
                setEconomyClass(true);
                setPremiumEcoClass(true);
            }
        }
        else {
            setFirstClass(true);
            setBusinessClass(true);
            setEconomyClass(true);
            setPremiumEcoClass(true);
            setIsAddPay(true);
            setIsForFamily(true);
            setIsPersonalTravel(false);
            setWalletAmount(1000000000);
        }
    }, []);
    useEffect(() => {
        if (policy !== null && policy.length > 0) {
            if (policy[0].policy !== null) {
                setFirstClass(policy[0].policy.firstClass);
                setBusinessClass(policy[0].policy.businessClass);
                setEconomyClass(policy[0].policy.economyClass);
                setPremiumEcoClass(policy[0].policy.premiumEcoClass);
            }
            if (policy[0].user !== null) {
                setIsAddPay(policy[0].user.isAddPay);
                setIsForFamily(policy[0].user.isForFamily);
                setIsPersonalTravel(policy[0].user.isPersonalTravel);
                setWalletAmount(policy[0].user.walletAmount);

                if (policy[0].user.policyId === 0) {
                    setIsAddPay(true);
                    setIsForFamily(true);
                    setIsPersonalTravel(false);
                    setWalletAmount(1000000000);
                    setFirstClass(true);
                    setBusinessClass(true);
                    setEconomyClass(true);
                    setPremiumEcoClass(true);
                }
            }
            else {
                setIsAddPay(false);
                setIsForFamily(false);
                setIsPersonalTravel(true);
                setWalletAmount(0);
            }
        }
        else {
            setIsAddPay(true);
            setIsForFamily(true);
            setIsPersonalTravel(false);
            setWalletAmount(1000000000);
            setFirstClass(true);
            setBusinessClass(true);
            setEconomyClass(true);
            setPremiumEcoClass(true);
        }
        if (isPersonalTravel) {
            setAdults(1);
            setChildren(0);
            setInfants(0);
        }
    }, [policy]);

    const fetchLocationData = async (query, setOptions) => {
        console.log("setOptions:", setOptions); // ✅ Debugging
        if (typeof setOptions !== "function") {
            console.error("🚨 setOptions is not a function! Check function call.");
            return;
        }
        if (!bearerToken) {
            console.error("No token found");
            return;
        }
        try {
            const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getAirportCityList?code=${query}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem("bearerToken");
                    window.location.href = "/login";
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            console.log("Fetched Data:", result); // ✅ Debugging API response

            setOptions(result);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const [isSecondCityVisible, setIsSecondCityVisible] = useState(false);

    const handleAddCity = () => {
        setIsSecondCityVisible(true);
    };

    const handleRemoveCity = () => {
        setIsSecondCityVisible(false);
        setTo3IataCode('');
        setTo3('');
    };
    const handleInputChange = (e) => {
        const query = e.target.value;
        setDeparture(query);
        setSearchQuery(query);
        setShowDropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setDepartureOptions); // Ensure function is passed correctly
        } else {
            setDepartureOptions(popularCities); // Show popular cities when search is cleared
        }
    };

    const handleDestinationChange = (e) => {
        const query = e.target.value;
        setDestination(query);
        setSearchQuery(query);
        setShowDestinationDropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setDestinationOptions); // Ensure function is passed correctly
        } else {
            setDestinationOptions(popularCities); // Show popular cities when search is cleared
        }
    };

    const handleFrom2Change = (e) => {
        const query = e.target.value;
        setFrom2(query);
        setSearchQuery(query);
        setShowFrom2Dropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setFrom2Options);
        } else {
            setFrom2Options(popularCities);
        }
    };

    const handleTo2Change = (e) => {
        const query = e.target.value;
        setTo2(query);
        setSearchQuery(query);
        setShowTo2Dropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setTo2Options);
        } else {
            setTo2Options(popularCities);
        }
    };
    const handleFrom3Change = (e) => {
        const query = e.target.value;
        setFrom3(query);
        setSearchQuery(query);
        setShowFrom3Dropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setFrom3Options);
        } else {
            setFrom3Options(popularCities);
        }
    };

    const handleTo3Change = (e) => {
        const query = e.target.value;
        setTo3(query);
        setSearchQuery(query);
        setShowTo3Dropdown(true);

        if (query.length > 1) {
            fetchLocationData(query, setTo3Options);
        } else {
            setTo3Options(popularCities);
        }
    };

    const handleCabinClassChange = (e) => {
        const selectedValue = e.target.value;
        setCabinClass(selectedValue);

        const selectedText = e.target.options[e.target.selectedIndex].text;
        setCabinClassText(selectedText);
    };

    const scrollIntoView = (index) => {
        const activeElement = document.getElementById(`option-${index}`);
        if (activeElement) {
            activeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
        const activeElementr = document.getElementById(`optionr-${index}`);
        if (activeElementr) {
            activeElementr.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
        const activeElementp = document.getElementById(`optionp-${index}`);
        if (activeElementp) {
            activeElementp.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    };

    const handleKeyDown = (event, options = [], type) => {
        if (!options || options.length === 0) return; // Prevent errors when options is empty

        setIsKeyboardActive(true); // Activate keyboard mode when a key is pressed
        setHoveredIndex(-1); // Disable hover when using keyboard

        if (event.key === "ArrowDown") {
            setActiveIndex((prev) => {
                const newIndex = prev < options.length - 1 ? prev + 1 : prev;
                scrollIntoView(newIndex);
                return newIndex;
            });
        } else if (event.key === "ArrowUp") {
            setActiveIndex((prev) => {
                const newIndex = prev > 0 ? prev - 1 : prev;
                scrollIntoView(newIndex);
                return newIndex;
            });
        } else if (event.key === "Enter" && activeIndex !== -1) {
            handleOptionSelect(options[activeIndex], type);
        }
    };


    const [previousFromValue, setPreviousFromValue] = useState("");
    const [previousFrom2Value, setPreviousFrom2Value] = useState("");
    const [previousFrom3Value, setPreviousFrom3Value] = useState("");
    const [previousToValue, setPreviousToValue] = useState("");
    const [previousTo2Value, setPreviousTo2Value] = useState("");
    const [previousTo3Value, setPreviousTo3Value] = useState("");

    const [searchQueryFrom1, setSearchQueryFrom1] = useState("");
    const [searchQueryFrom2, setSearchQueryFrom2] = useState("");
    const [searchQueryFrom3, setSearchQueryFrom3] = useState("");
    const [searchQueryTo1, setSearchQueryTo1] = useState("");
    const [searchQueryTo2, setSearchQueryTo2] = useState("");
    const [searchQueryTo3, setSearchQueryTo3] = useState("");

    const handleSearchInputChange = (e, type) => {
        const value = e.target.value;

        switch (type) {
            case "from":
                setSearchQueryFrom1(value);
                handleInputChange(e);
                break;
            case "from2":
                setSearchQueryFrom2(value);
                handleFrom2Change(e);
                break;
            case "from3":
                setSearchQueryFrom3(value);
                handleFrom3Change(e);
                break;
            case "to":
                setSearchQueryTo1(value);
                handleDestinationChange(e);
                break;
            case "to2":
                setSearchQueryTo2(value);
                handleTo2Change(e);
                break;
            case "to3":
                setSearchQueryTo3(value);
                handleTo3Change(e);
                break;
            default:
                break;
        }
    };
    const handleOptionSelect = (option, type) => {
        switch (type) {
            case 'from':
                setDeparture(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setDepartureIataCode(option.iata_code);
                setSearchQueryFrom1("");
                setShowDropdown(false);
                break;
            case 'to':
                setDestination(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setDestinationIataCode(option.iata_code);
                setSearchQueryTo1("");
                setShowDestinationDropdown(false);
                break;
            case 'from2':
                setFrom2(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setFrom2IataCode(option.iata_code);
                setSearchQueryFrom2("");
                setShowFrom2Dropdown(false);
                break;
            case 'to2':
                setTo2(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setTo2IataCode(option.iata_code);
                setSearchQueryTo2("");
                setShowTo2Dropdown(false);
                break;
            case 'from3':
                setFrom3(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setFrom3IataCode(option.iata_code);
                setSearchQueryFrom3("");
                setShowFrom3Dropdown(false);
                break;
            case 'to3':
                setTo3(`${option.iata_code}, ${option.name}, ${option.municipality}`);
                setTo3IataCode(option.iata_code);
                setSearchQueryTo3("");
                setShowTo3Dropdown(false);
                break;
            default:
                break;
        }
        setTimeout(() => {
            setShowDropdown(false);
            setShowDestinationDropdown(false);
            setShowFrom2Dropdown(false);
            setShowTo2Dropdown(false);
            setShowFrom3Dropdown(false);
            setShowTo3Dropdown(false);
        }, 100);
        setRecentSearches((prevSearches) => {
            const updatedSearches = prevSearches.filter(
                (search) => search.iata_code !== option.iata_code
            );
            const newSearches = [option, ...updatedSearches].slice(0, 5);
            localStorage.setItem("recentSearches", JSON.stringify(newSearches));
            return newSearches;
        });
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleDropdownClose = (type) => {
        if (type === "from" && searchQuery === "") setSearchQuery(previousFromValue);
        if (type === "from2" && searchQuery === "") setSearchQuery(previousFrom2Value);
        if (type === "from3" && searchQuery === "") setSearchQuery(previousFrom3Value);
        if (type === "to" && searchQuery === "") setSearchQuery(previousToValue);
        if (type === "to2" && searchQuery === "") setSearchQuery(previousTo2Value);
        if (type === "to3" && searchQuery === "") setSearchQuery(previousTo3Value);

        setShowDropdown(false);
        setShowDestinationDropdown(false);
        setShowFrom2Dropdown(false);
        setShowTo2Dropdown(false);
        setShowFrom3Dropdown(false);
        setShowTo3Dropdown(false);
    };
    const handleInputFocus = (type) => {
        switch (type) {
            case "from":
                setShowDropdown(true);
                setSearchQueryFrom1("");
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
                break;
            case "to":
                setShowDropdown(false);
                setShowDestinationDropdown(true);
                setSearchQueryTo1("");
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
                break;
            case "from2":
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(true);
                setSearchQueryFrom2("");
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
                break;
            case "to2":
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(true);
                setSearchQueryTo2("");
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(false);
                break;
            case "from3":
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(true);
                setSearchQueryFrom3("");
                setShowTo3Dropdown(false);
                break;
            case "to3":
                setShowDropdown(false);
                setShowDestinationDropdown(false);
                setShowFrom2Dropdown(false);
                setShowTo2Dropdown(false);
                setShowFrom3Dropdown(false);
                setShowTo3Dropdown(true);
                setSearchQueryTo3("");
                break;
            default:
                break;
        }

        setTimeout(() => {
            if (inputRefs[type].current) {
                inputRefs[type].current.focus();
            }
        }, 100);
    };
    const renderDropdown = (options, type, searchQuery, setSearchQuery, inputRef) => {
        return (
            <div ref={dropdownRef} className="dropdown-home-main" style={{ height: "500px", width: "100%" }}>
                <input
                    type="text"
                    ref={inputRef}
                    placeholder={type.includes('from') ? "From" : "To"}
                    id={type + "1"}
                    value={searchQuery || ""}
                    autoComplete="off"
                    onChange={(e) => { setSearchQuery(e.target.value); handleSearchInputChange(e, type) }}
                    onKeyDown={(e) => handleKeyDown(e, options, type)}
                    onFocus={(e) => e.target.select()}
                    className="search-bar-home"
                />

                {searchQuery.length === 0 && recentSearches.length > 0 && recentSearches.some(item => item.name && item.name.trim() !== '') && (
                    <>
                        <p className="headingdrops m-0">Recent Searches</p>
                        <div className="headinglistsdrops" tabIndex={0} onKeyDown={handleKeyDown}>
                            {recentSearches
                                .filter(item => item.name && item.name.trim() !== '')
                                .map((item, index) => (
                                    <div
                                        key={index}
                                        style={{ background: index === activeIndex ? "#e0e0e0" : "white", cursor: "pointer" }}
                                        onClick={() => handleOptionSelect(item, type)}
                                        id={`optionr-${index}`}>

                                        <div key={index} onClick={() => handleOptionSelect(item, type)} id={`optionr-${index}`} className="droplistmain">
                                            <div style={{ height: "20px", width: "20px" }}>
                                                <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                                            </div>
                                            <div className="flightCityCountry">
                                                <p className="m-0">
                                                    {item.municipality}, {item.countryName}
                                                </p>
                                                <p className="text-muted" style={{ fontSize: "11px", fontWeight: "300" }}>
                                                    {item.name}
                                                </p>
                                            </div>
                                            <div className="text-muted">
                                                {item.iata_code}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </>
                )}

                {searchQuery.length === 0 && popularCities.length > 0 && (
                    <>
                        <p className="headingdrops m-0">Popular Cities</p>
                        <div className="headinglistsdrops" tabIndex={0} onKeyDown={handleKeyDown}>
                            {popularCities.map((option, index) => {
                                const isActive = isKeyboardActive && activeIndex === index;
                                const isHovered = !isKeyboardActive && hoveredIndex === index;

                                return (
                                    <div
                                        key={index}
                                        className="droplistmain"
                                        id={`optionp-${index}`}
                                        onClick={() => handleOptionSelect(option, type)}
                                        onMouseEnter={() => {
                                            setHoveredIndex(index);
                                            setIsKeyboardActive(false); // Disable keyboard tracking on mouse hover
                                        }}
                                        onMouseLeave={() => setHoveredIndex(-1)}
                                        style={{
                                            background: isHovered ? "lightgrey" : isActive ? "#e0e0e0" : "white",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div style={{ height: "20px", width: "20px" }}>
                                            <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                                        </div>
                                        <div className="flightCityCountry">
                                            <p className="m-0">
                                                {option.municipality}, {option.countryName}
                                            </p>
                                            <p className="text-muted" style={{ fontSize: "11px", fontWeight: "300" }}>
                                                {option.name}
                                            </p>
                                        </div>
                                        <div className="text-muted">{option.iata_code}</div>
                                    </div>
                                );
                            })}
                        </div>

                    </>
                )}

                {searchQuery.length > 0 && options.length > 0 && (
                    <>
                        <p className="headingdrops m-0">Search Results</p>
                        <div className="headinglistsdrops">
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    className={`${index === activeIndex ? "active" : ""} `}
                                    id={`option-${index}`}
                                    style={{ background: index === activeIndex ? "#e0e0e0" : "white", cursor: "pointer" }}
                                    onClick={() => handleOptionSelect(option, type)}
                                >
                                    <div key={index} onClick={() => handleOptionSelect(option, type)} id={`option-${index}`} className="droplistmain">
                                        <div style={{ height: "20px", width: "20px" }}>
                                            <FontAwesomeIcon icon={faPlaneDeparture} color="grey" />
                                        </div>
                                        <div className="flightCityCountry">
                                            <p className="m-0">
                                                {option.municipality}, {option.countryName}
                                            </p>
                                            <p className="text-muted" style={{ fontSize: "10px", fontWeight: "300" }}>
                                                {option.name}
                                            </p>
                                        </div>
                                        <div className="text-muted">
                                            {option.iata_code}
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        );
    };
    const maxPassengers = 9;
    // const saveSearchCriteria = (searchData) => {
    //     localStorage.setItem("searchCriteria", JSON.stringify(searchData));
    // };
    // useEffect(() => {
    //     setSearchQuery(searchData || "");
    // }, []);
    const handleAddPassenger = (type, count) => {
        const totalPassengers = adults + children + infants;
        if (totalPassengers >= maxPassengers && count === 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Passenger Limit Exceeded',
                text: 'You cannot select more than 9 passengers.'
            });
            return;
        }
        if (type === "adult") {
            if (adults < 1) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Adult Required',
                    text: 'At least one adult is required.'
                });
                return;
            }
            setAdults(adults + count);
        } else if (type === "child") {
            setChildren(children + count);
        } else if (type === "infant") {
            if (infants === adults && count === 1) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Infant Limit Exceeded',
                    text: 'Infants cannot exceed the number of adults.'
                });
                return;
            }
            setInfants(infants + count);
        }
        if (isPersonalTravel) {
            setAdults(1);
            setChildren(0);
            setInfants(0);
        }
    };

    const saveRecentSearches = async () => {
        let mc = '';
        try {
            if (tripType === "3") {
                mc = from2 + "|" + to2 + "|" + depart2.toLocaleDateString('en-CA');
                if (isSecondCityVisible) {
                    mc += "$" + from3 + "|" + to3 + "|" + depart3.toLocaleDateString('en-CA');
                }
            }

            const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/SaveRecentSearches`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                },
                body: JSON.stringify({
                    origin: departure,
                    destination: destination,
                    cabin: cabinClass,
                    fromdt: startDate.toLocaleDateString('en-CA'),
                    todt: returnDate ? returnDate.toLocaleDateString('en-CA') : '',
                    adult: adults,
                    child: children,
                    infant: infants,
                    isRound: tripType,
                    fareType: fareType,
                    isRF: isNRF,
                    mc: mc,
                    currency: currency
                }),
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const result = await response.text();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const getRecentSearches = async () => {
        try {
            const cachedSearches = localStorage.getItem("recentSearches");
            if (cachedSearches) {
                setRecentSearches(JSON.parse(cachedSearches));
                return; // Prevents unnecessary API calls
            }

            const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getRecentSearches`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem("bearerToken");
                    window.location.href = "/login";
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();

            // Prevent unnecessary re-renders
            setRecentSearches((prevSearches) => {
                if (JSON.stringify(prevSearches) !== JSON.stringify(result)) {
                    return result;
                }
                return prevSearches; // If data is same, don't update state
            });

            localStorage.setItem("recentSearches", JSON.stringify(result));
        } catch (error) {
            console.error("Error fetching recent search data:", error);
        }
    };

    useEffect(() => {
        if (!recent || recent.length === 0) {
            getRecentSearches();
        }
    }, [bearerToken]);
    const setCurrentRecent = (index) => {
        if (recent) {
            setIndex(index);
            setDeparture(recent[index].origin);
            setDepartureIataCode(recent[index].origin.split(',')[0]);
            setDestination(recent[index].destination);
            setDestinationIataCode(recent[index].destination.split(',')[0]);
            //setStartDate(new Date(recent[index].fromdt).setHours(0,0,0));
            setStartDate(new Date(new Date(recent[index].fromdt).setUTCHours(0, 0, 0, 0)));
            if (tripType === 2)
                setReturnDate(new Date(recent[index].todt));
            setAdults(recent[index].adult);
            setChildren(recent[index].child);
            setInfants(recent[index].infant);
            setCabinClass(recent[index].cabin);
            if (recent[index].cabin === 'Y')
                setCabinClassText('Economy');
            if (recent[index].cabin === 'W')
                setCabinClassText('Premium Economy');
            if (recent[index].cabin === 'C')
                setCabinClassText('Business Class');
            if (recent[index].cabin === 'F')
                setCabinClassText('First Class');
            setIsNRF(recent[index].isRF);
            handleTripTypeChange(recent[index].isRound.toString());
            setCurrency(recent[index].currency);
            setFareType(recent[index].fareType);

            if (recent[index].isRound.toString() === "3") {
                if (destination) {
                    setFrom2(destination);
                    setFrom2IataCode(destinationIataCode);
                }
                const mc = recent[index].mc;
                if (mc && mc !== '') {
                    const mcSegments = mc.split('$');

                    const firstSegment = mcSegments[0].split('|');
                    if (firstSegment.length >= 3) {
                        setTo2(firstSegment[1]);
                        setTo2IataCode(firstSegment[1].split(',')[0]);
                        setDepart2(new Date(firstSegment[2]));
                    }

                    if (mcSegments.length > 1) {
                        const secondSegment = mcSegments[1].split('|');
                        if (secondSegment.length >= 3) {
                            setIsSecondCityVisible(true);
                            setTo3(secondSegment[1]);
                            setTo3IataCode(secondSegment[1].split(',')[0]);
                            setDepart3(new Date(secondSegment[2]));
                        }
                    }
                }
            }
        }
    };
    const searchButton = async (query) => {

        if (departure === '') {
            await Swal.fire({
                icon: 'warning',
                title: 'Missing Departure',
                text: 'Please select departure.'
            });
            return;
        }
        if (destination === '') {
            await Swal.fire({
                icon: 'warning',
                title: 'Missing Destination',
                text: 'Please select destination.'
            });
            return;
        }
        if (destination === departure) {
            await Swal.fire({
                icon: 'warning',
                title: 'Same City Selected',
                text: 'Please select different Cities.'
            });
            return;
        }
        if (!departure.includes(',')) {
            await Swal.fire({
                icon: 'warning',
                title: 'Invalid Departure Selection',
                text: 'Please select departure option.'
            });
            return;
        }
        if (!destination.includes(',')) {
            await Swal.fire({
                icon: 'warning',
                title: 'Invalid Destination Selection',
                text: 'Please select destination option.'
            });
            return;
        }
        if (tripType === '2' && !returnDate) {//&& returnDate < startDate
            await Swal.fire({
                icon: 'warning',
                title: 'Missing Return Date',
                text: 'Please select a return date that is not earlier than the departure date.'
            });
            return;
        }
        let mc = '';
        try {
            if (tripType === "3") {
                if (from2 === '') {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Missing Departure',
                        text: 'Please select departure.'
                    });
                    return;
                }
                else if (to2 === '') {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Missing Destination',
                        text: 'Please select destination.'
                    });
                    return;
                }
                else if (!from2.includes(',')) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Invalid Departure Selection',
                        text: 'Please select departure option.'
                    });
                    return;
                }
                else if (!to2.includes(',')) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Invalid Destination Selection',
                        text: 'Please select destination option.'
                    });
                    return;
                }
                else if (from2 === to2) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Same City Selected',
                        text: 'Please select different Cities.'
                    });
                    return;
                }
                else {
                    mc = from2 + "|" + to2 + "|" + depart2.toLocaleDateString('en-CA');
                }
                if (isSecondCityVisible) {
                    if (from3 === '') {
                        await Swal.fire({
                            icon: 'warning',
                            title: 'Missing Departure',
                            text: 'Please select departure.'
                        });
                        return;
                    }
                    else if (to3 === '') {
                        await Swal.fire({
                            icon: 'warning',
                            title: 'Missing Destination',
                            text: 'Please select destination.'
                        });
                        return;
                    }
                    else {
                        mc += "$" + from3 + "|" + to3 + "|" + depart3.toLocaleDateString('en-CA');
                    }
                }
            }
            setLoading(true);
            // saveRecentSearches();

            const queryParamsObject = {
                adults: adults,
                children: children,
                infant: infants,
                cabin: cabinClass,
                ip: "::1",
                JourneyType: tripType === '2' ? 2 : 1,
                stops: true,
                origan: departure,
                destination: destination,
                segments: JSON.stringify([
                    {
                        depcode: departureIataCode,
                        arrcode: destinationIataCode,
                        depdate: startDate.toLocaleDateString('en-CA')
                    },
                    ...(tripType === '2' && returnDate
                        ? [{
                            depcode: destinationIataCode,
                            arrcode: departureIataCode,
                            depdate: returnDate.toLocaleDateString('en-CA')
                        }]
                        : [])
                ])
            };


            const queryParams = new URLSearchParams(queryParamsObject).toString();
            // const newSearchData = { ...searchData, queryParams };
            // setSearchDatas(newSearchData);
            // saveSearchCriteria(newSearchData);
            navigate(`/listing-page?${queryParams}`);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const swapValues = () => {
        const dept = departure;
        const deptiata = departureIataCode;
        setDeparture(destination);
        setDepartureIataCode(destinationIataCode);
        setDestination(dept);
        setDestinationIataCode(deptiata);
    };
    useEffect(() => {
        if (destination) {
            setFrom2(destination);
            setFrom2IataCode(destinationIataCode);
        }
    }, [destination, destinationIataCode]);

    useEffect(() => {
        if (to2) {
            setFrom3(to2);
            setFrom3IataCode(to2IataCode);
        }
    }, [to2, to2IataCode]);

    useEffect(() => {
        if (startDate) {
            if (tripType === '2')
                setReturnDate(new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)));
            if (tripType === "3")
                setDepart2(startDate);
            if (recent && recent[index] && recent[index].isRound.toString() === "3") {
                setDepart2(new Date(recent[index].mc.split('$')[0].split('|')[2]));
            }
        }
    }, [startDate, recent, index]);

    useEffect(() => {
        if (depart2) {
            if (tripType === "3")
                setDepart3(depart2);
            if (recent && recent[index] && recent[index].isRound.toString() === "3" && recent[index].mc.split('$')[1]) {
                setDepart3(new Date(recent[index].mc.split('$')[1].split('|')[2]));
            }
        }
    }, [depart2, recent, index]);

    // ---------------------------for closing traveller modal ------------------------------
    const modalRef = useRef(null);
    const triggerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                modalRef.current && !modalRef.current.contains(event.target) &&
                triggerRef.current && !triggerRef.current.contains(event.target)
            ) {
                setShowTravelerModal(false);
            }
        };

        if (showTravelerModal) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showTravelerModal]);

    // ---------------------------for closing traveller modal ------------------------------

    const [recentSearches, setRecentSearches] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        getRecentSearches();
    }, []);


    return (
        <>

            <div className="mainContainerForm">
                {/* <Slider {...settings} className="slider-container-homepage">
                    <div>
                        <img src="/assets/images/sliderImg1.jpg" alt="Slide 1" />
                    </div>
                    <div>
                        <img src="/assets/images/sliderImg2.jpg" alt="Slide 2" />
                    </div>
                    <div>
                        <img src="/assets/images/sliderImg3.jpg" alt="Slide 3" />
                    </div>
                    <div>
                        <img src="/assets/images/sliderImg4.jpg" alt="Slide 3" />
                    </div>
                </Slider> */}
                <div
                    className="slider-background-homepage"
                    style={{
                        width: "100%",
                        height: "253px",
                        backgroundImage: 'url("assets/images/Form-Background-Image.png")',
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "12px"
                    }}
                />
                <div style={{ width: "100%", display: "flex", justifyContent: "center", position: "" }} className="textdiv"><h2 style={{ position: "relative", marginTop: "-216px" }}>Book Domestic and International Flight Tickets</h2></div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", position: "relative" }}>
                    <div className="flight-search-container">
                        <div className="flight-options-container">
                            <div className="flight-options1">
                                <label className="">
                                    <input
                                        type="radio"
                                        name="trip-type"
                                        checked={tripType === '1'}
                                        onChange={() => handleTripTypeChange('1')}
                                    /> One Way
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="trip-type"
                                        checked={tripType === '2'}
                                        onChange={() => handleTripTypeChange('2')}
                                    /> Round Trip
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="trip-type"
                                        checked={tripType === '3'}
                                        onChange={() => handleTripTypeChange('3')}
                                    /> Multi-city
                                </label>
                            </div>
                            <div className="flight-options2">
                                <select name="currency" id="currency" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                                    <option value="INR">INR</option>
                                    <option value="AED">AED</option>
                                    <option value="EUR">EUR</option>
                                    <option value="USD">USD</option>
                                </select>
                                <select
                                    name="fareType"
                                    id="fareType"
                                    value={fareType}
                                    onChange={(e) => setFareType(e.target.value)}
                                    onMouseOut={() => setTooltip("")}
                                >
                                    {fareTypeoptions.map((option) => (
                                        <option
                                            key={option.value}
                                            value={option.value}
                                            onMouseOver={() => setTooltip(option.description)}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {tooltip && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: "0",
                                            backgroundColor: "#333",
                                            color: "#fff",
                                            padding: "5px",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            marginTop: "5px",
                                        }}
                                    >
                                        {tooltip}
                                    </div>
                                )}
                                <select name="isNRF" id="isNRF" value={isNRF} onChange={(e) => setIsNRF(e.target.value)}>
                                    <option value="0">All</option>
                                    <option value="1">Refundable</option>
                                    <option value="2">Non-Refundable</option>
                                </select>
                            </div>
                        </div>
                        <div className="flight-search">
                            <div
                                className="input-wrapper"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setShowDropdown(true);
                                    setShowDestinationDropdown(false);
                                    setShowFrom2Dropdown(false);
                                    setShowTo2Dropdown(false);
                                    setShowFrom3Dropdown(false);
                                    setShowTo3Dropdown(false);
                                    handleInputFocus("from");
                                }}
                            >
                                <label htmlFor="from">From</label>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <input
                                        type="text"
                                        id="from"
                                        value={departure ? departure.split(",")[2] : ""}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleKeyDown(e, departureOptions, 'from')}
                                        onFocus={(e) => {
                                            setShowDropdown(true);
                                            setShowDestinationDropdown(false);
                                            setShowFrom2Dropdown(false);
                                            setShowTo2Dropdown(false);
                                            setShowFrom3Dropdown(false);
                                            setShowTo3Dropdown(false);
                                            handleInputFocus("from");
                                        }}
                                        autoComplete="off"
                                        placeholder="Enter City"
                                        className="metropolis-bold"
                                        style={{
                                            margin: "0",
                                            fontSize: "20px",
                                            textAlign: "left",
                                            paddingLeft: "7px",
                                            height: "38px",
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            background: "transparent"
                                        }}
                                    />
                                    {/* <p className="text-start px-3 text-dark">{departure}</p> */}
                                    {showDropdown && renderDropdown(departureOptions, 'from', searchQueryFrom1, setSearchQueryFrom1, inputRefs.from)}
                                </div>
                            </div>

                            <div className="swap-icon">
                                <button type="button" onClick={swapValues}><img src="./assets/images/swapImg.png" alt="" className="" /></button>
                            </div>
                            <div
                                className="input-wrapper"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setShowDropdown(false);
                                    setShowDestinationDropdown(true);
                                    setShowFrom2Dropdown(false);
                                    setShowTo2Dropdown(false);
                                    setShowFrom3Dropdown(false);
                                    setShowTo3Dropdown(false);
                                    handleInputFocus("to");
                                }}
                            >
                                <label htmlFor="to">To</label>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <input
                                        type="text"
                                        value={destination ? destination.split(",")[2] : ""}
                                        onKeyDown={(e) => handleKeyDown(e, destinationOptions, 'to')}
                                        onFocus={(e) => {
                                            setShowDropdown(false);
                                            setShowDestinationDropdown(true);
                                            setShowFrom2Dropdown(false);
                                            setShowTo2Dropdown(false);
                                            setShowFrom3Dropdown(false);
                                            setShowTo3Dropdown(false);
                                            handleInputFocus("to");
                                        }}
                                        autoComplete="off"
                                        onChange={handleDestinationChange}
                                        id="to"
                                        style={{
                                            marginLeft: "7px",
                                            fontSize: "20px",
                                            textAlign: "left",
                                            paddingLeft: "7px",
                                            height: "38px",
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            background: "transparent"
                                        }}
                                        className="metropolis-bold"
                                        placeholder="Enter City"
                                    />
                                    {/* <p className="text-start px-3 text-dark">{destination}</p> */}
                                    {showDestinationDropdown && renderDropdown(destinationOptions, 'to', searchQueryTo1, setSearchQueryTo1, inputRefs.to)}
                                </div>
                            </div>
                            <div className="input-group smallwidthBoxes">
                                <label className="custom-label">Depart</label>
                                <div
                                    style={{ border: "1px solid #E0E0E0", height: "70px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center" }}
                                    onClick={() => datepickerRef.current.setFocus()}
                                >
                                    <DatePicker
                                        ref={datepickerRef}
                                        selected={startDate}
                                        onChange={date => setStartDate(date)}
                                        placeholderText="Select Date"
                                        dateFormat="dd MMM yy"
                                        className="testDrop metropolis-bold "
                                        minDate={new Date()}
                                    />
                                    {/* <p style={{ fontSize: "14px", textAlign: "left", paddingLeft: "10px" }}>
                                    {startDate ? startDate.toLocaleDateString('en-US', { weekday: 'long' }) : "Select a date"}
                                </p> */}
                                </div>
                            </div>
                            <div className="input-group smallwidthBoxes">
                                <label className="custom-label">Return</label>
                                <div style={{ border: "1px solid #E0E0E0", height: "70px", borderRadius: "6px", display: "flex", alignItems: "center" }}
                                    onClick={() => datePickerRef.current?.setFocus()} >
                                    <DatePicker
                                        style={{ marginTop: "17px" }}
                                        ref={datePickerRef}
                                        selected={returnDate}
                                        placeholderText=" Select Return"
                                        onChange={(date) => {
                                            setReturnDate(date);
                                            setTripType("2");
                                        }}
                                        dateFormat="dd MMM yy"
                                        className="date-input testDrop metropolis-bold  "
                                        minDate={startDate}

                                        maxDate={startDate ? new Date(startDate.getTime() + 360 * 24 * 60 * 60 * 1000) : null}
                                    />

                                    <p
                                        className={`return-text `}
                                        style={{ fontSize: "14px", textAlign: "left", paddingLeft: "10px", cursor: "pointer", position: "absolute", top: "58px" }}
                                        onClick={() => {
                                            setTripType("2");
                                            if (!returnDate && startDate) {
                                                setReturnDate(new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000));
                                            }
                                            if (datePickerRef.current) {
                                                datePickerRef.current.setFocus();
                                            }
                                        }}
                                    >
                                    </p>

                                    {/* <span>Select Return</span> */}
                                </div>
                            </div>
                            <div className="input-wrapper travellerHover smallwidthBoxes">
                                <label>Travelers & Class</label>
                                <div className="traveler-input" ref={triggerRef} onClick={handleTravelerModalToggle} style={{ padding: "0px 0px 0px 15px", fontWeight: "bold", fontSize: "15px", overflow: "hidden", display: "flex", alignItems: "center" }}>
                                    {adults} Adult{adults > 1 ? 's' : ''}
                                    {children > 0 && `, ${children} Child${children > 1 ? 'ren' : ''}`}
                                    {infants > 0 && `, ${infants} Infant${infants > 1 ? 's' : ''}`}, {cabinClassText}
                                </div>
                            </div>
                        </div>
                        {showTravelerModal && (
                            <div className="traveler-modal" ref={modalRef}>
                                <div className="modal-content">
                                    <label className="fw-bold text-start">Cabin class</label>
                                    <select id="cabinClass" name="cabinClass" value={cabinClass} onChange={handleCabinClassChange} className="arrow-drop-home">
                                        {economyClass && (<option value="Y">Economy</option>)}
                                        {premiumEcoClass && (<option value="W">Premium Economy</option>)}
                                        {businessClass && (<option value="C">Business Class</option>)}
                                        {firstClass && (<option value="F">First Class</option>)}
                                    </select>
                                    <div className="passenger-count">
                                        <label className="col-lg-6 text-start">Adults (Age 12+)</label>
                                        <div className="col-lg-6">
                                            <button onClick={() => handleAddPassenger("adult", -1)} disabled={adults <= 1}>
                                                <img
                                                    src={adults > 1 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                                                    alt="Traveller Icon"
                                                />
                                            </button>
                                            <span>{adults}</span>
                                            {!isPersonalTravel && (
                                                <button onClick={() => handleAddPassenger("adult", 1)}>
                                                    <img src="./assets/images/Add.png" alt="" />
                                                </button>)}
                                        </div>
                                    </div>
                                    {isForFamily && (
                                        <>
                                            <div className="passenger-count">
                                                <label className="col-lg-6 text-start">Children (Age 2-11)</label>
                                                <div className="col-lg-6">
                                                    <button onClick={() => handleAddPassenger("child", -1)} disabled={children <= 0}>
                                                        <img
                                                            src={children > 0 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                                                            alt="Traveller Icon"
                                                        />
                                                    </button>
                                                    <span>{children}</span>
                                                    <button
                                                        onClick={() => handleAddPassenger("child", 1)}
                                                    //disabled={adults + children + infants >= 9}
                                                    >
                                                        <img src="./assets/images/Add.png" alt="" />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="passenger-count">
                                                <label className="col-lg-6 text-start">Infants (Age 0-2)</label>
                                                <div className="col-lg-6">
                                                    <button onClick={() => handleAddPassenger("infant", -1)} disabled={infants <= 0}>
                                                        <img
                                                            src={infants > 0 ? "./assets/images/MinusActive.png" : "./assets/images/minusTraveller.png"}
                                                            alt="Traveller Icon"
                                                        />
                                                    </button>
                                                    <span>{infants}</span>
                                                    <button
                                                        onClick={() => handleAddPassenger("infant", 1)}
                                                    //disabled={infants >= adults || adults + children + infants >= 9}
                                                    >
                                                        <img src="./assets/images/Add.png" alt="" />
                                                    </button>
                                                </div>
                                            </div></>)}
                                    <button className="apply-button" onClick={handleTravelerModalToggle}>Apply</button>
                                </div>
                            </div>
                        )}
                        {/* For Multi-city, add another form */}
                        {tripType === '3' && (
                            <>
                                <div className="flight-search multi-city multiMainContainer">
                                    <div
                                        className="input-wrapper multiCityForm"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setShowDropdown(false);
                                            setShowDestinationDropdown(false);
                                            setShowFrom2Dropdown(true);
                                            setShowTo2Dropdown(false);
                                            setShowFrom3Dropdown(false);
                                            setShowTo3Dropdown(false);
                                            handleInputFocus("from2");
                                        }}
                                    >
                                        <label htmlFor="from-2">From</label>
                                        <div style={{ border: "1px solid #E6E6E6", height: "98px" }}>
                                            <input
                                                type="text"
                                                id="from-2"
                                                value={from2 ? from2.split(',')[2] : ""}
                                                onChange={handleFrom2Change}
                                                onFocus={(e) => {
                                                    setShowDropdown(false);
                                                    setShowDestinationDropdown(false);
                                                    setShowFrom2Dropdown(true);
                                                    setShowTo2Dropdown(false);
                                                    setShowFrom3Dropdown(false);
                                                    setShowTo3Dropdown(false);
                                                    handleInputFocus("from2");
                                                }}
                                                autoComplete="off"
                                                onKeyDown={(e) => handleKeyDown(e, from2Options, 'from2')}
                                                style={{
                                                    margin: "0",
                                                    fontSize: "30px",
                                                    textAlign: "left",
                                                    paddingLeft: "7px",
                                                    height: "38px",
                                                    width: "100%",
                                                    border: "none",
                                                    outline: "none",
                                                    background: "transparent"
                                                }}
                                                className="metropolis-bold" placeholder="Enter City"
                                            />
                                            <p className="text-start px-3">{from2}</p>
                                            {showFrom2Dropdown && renderDropdown(from2Options, 'from2', searchQueryFrom2, setSearchQueryFrom2, inputRefs.from2)}
                                        </div>
                                    </div>
                                    <div className="input-wrapper multiCityForm"
                                        onClick={() => {
                                            document.getElementById("to-2").focus();
                                            setShowDropdown(false);
                                            setShowDestinationDropdown(false);
                                            setShowFrom2Dropdown(false);
                                            setShowTo2Dropdown(true);
                                            setShowFrom3Dropdown(false);
                                            setShowTo3Dropdown(false);
                                            handleInputFocus("to2");
                                        }}
                                        style={{ cursor: "pointer" }}>
                                        <label htmlFor="to-2">To</label>
                                        <div style={{ border: "1px solid #E6E6E6", height: "98px" }}>
                                            <input
                                                type="text"
                                                id="to-2"
                                                value={to2 ? to2.split(',')[2] : ""}
                                                onKeyDown={(e) => handleKeyDown(e, to2Options, 'to2')}
                                                autoComplete="off"
                                                onFocus={(e) => {
                                                    setShowDropdown(false);
                                                    setShowDestinationDropdown(false);
                                                    setShowFrom2Dropdown(false);
                                                    setShowTo2Dropdown(true);
                                                    setShowFrom3Dropdown(false);
                                                    setShowTo3Dropdown(false);
                                                    handleInputFocus("to2");
                                                }}
                                                onChange={handleTo2Change}
                                                style={{ margin: "0", fontSize: "30px", textAlign: "left", paddingLeft: "8px", height: "38px" }}
                                                className="metropolis-bold" placeholder="Select City" /><p className="text-start px-3">{to2}</p>
                                            {showTo2Dropdown && renderDropdown(to2Options, 'to2', searchQueryTo2, setSearchQueryTo2, inputRefs.to2)}

                                        </div>

                                    </div>
                                    <div className="input-group multiCityForm multiDepartWidth" onClick={() => datePickerRef2.current?.setFocus()}>
                                        <label className="custom-label" htmlFor="depart-2">Depart</label>
                                        <div style={{ border: "1px solid #E0E0E0", height: "70px", borderRadius: "6px" }}>
                                            <DatePicker
                                                ref={datePickerRef2}
                                                selected={depart2}
                                                onChange={date => setDepart2(date)}
                                                placeholderText="Select Date"
                                                dateFormat="dd MMM yy"
                                                className="testDrop metropolis-bold "
                                                minDate={startDate || new Date()}
                                            />
                                            <p style={{ fontSize: "14px", textAlign: "left", paddingLeft: "10px" }}>{depart2 ? depart2.toLocaleDateString('en-US', { weekday: 'long' }) : "Select a date"}</p>
                                        </div>
                                    </div>
                                    {!isSecondCityVisible && (
                                        <div className="addCityFlight" onClick={handleAddCity}>
                                            Add City
                                        </div>
                                    )}
                                </div>
                                {isSecondCityVisible && (
                                    <div className="flight-search multi-city multiMainContainer1">
                                        <div className="input-wrapper multiCityForm1" onClick={() => {
                                            document.getElementById("from-3").focus();
                                            setShowDropdown(false);
                                            setShowDestinationDropdown(false);
                                            setShowFrom2Dropdown(false);
                                            setShowTo2Dropdown(false);
                                            setShowFrom3Dropdown(true);
                                            setShowTo3Dropdown(false);
                                            handleInputFocus("from3");
                                        }}
                                            style={{ cursor: "pointer" }}>
                                            <label htmlFor="from-3">From</label>
                                            <div style={{ border: "1px solid #E6E6E6", height: "98px" }}>
                                                <input
                                                    type="text"
                                                    id="from-3"
                                                    value={from3 ? from3.split(',')[2] : ""}
                                                    onChange={handleFrom3Change}
                                                    autoComplete="off"
                                                    onFocus={(e) => {
                                                        setShowDropdown(false);
                                                        setShowDestinationDropdown(false);
                                                        setShowFrom2Dropdown(false);
                                                        setShowTo2Dropdown(false);
                                                        setShowFrom3Dropdown(true);
                                                        setShowTo3Dropdown(false);
                                                        handleInputFocus("from3");
                                                    }}
                                                    onKeyDown={(e) => handleKeyDown(e, from3Options, 'from3')}
                                                    style={{ margin: "0", fontSize: "30px", textAlign: "left", paddingLeft: "8px", height: "38px" }} className="metropolis-bold" placeholder="Select City" />
                                                <p className="text-start px-3">{from3}</p>
                                                {showFrom3Dropdown && renderDropdown(from3Options, 'from3', searchQueryFrom3, setSearchQueryFrom3, inputRefs.from3)}

                                            </div>

                                        </div>
                                        <div
                                            className="input-wrapper multiCityForm1"
                                            onClick={() => {
                                                if (inputRefs.to3 && inputRefs.to3.current) {
                                                    inputRefs.to3.current.focus();
                                                }
                                                setShowDropdown(false);
                                                setShowDestinationDropdown(false);
                                                setShowFrom2Dropdown(false);
                                                setShowTo2Dropdown(false);
                                                setShowFrom3Dropdown(false);
                                                setShowTo3Dropdown(true);
                                                handleInputFocus("to3");
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <label htmlFor="to-3">To</label>
                                            <div style={{ border: "1px solid #E6E6E6", height: "98px" }}>
                                                <input
                                                    type="text"
                                                    id="to-3"
                                                    ref={inputRefs.to3}
                                                    value={to3 ? to3.split(',')[2] : ""}
                                                    onKeyDown={(e) => handleKeyDown(e, to3Options, 'to3')}
                                                    autoComplete="off"
                                                    onFocus={(e) => {
                                                        setShowDropdown(false);
                                                        setShowDestinationDropdown(false);
                                                        setShowFrom2Dropdown(false);
                                                        setShowTo2Dropdown(false);
                                                        setShowFrom3Dropdown(false);
                                                        setShowTo3Dropdown(true);
                                                        handleInputFocus("to3");
                                                    }}
                                                    onChange={handleTo3Change}
                                                    style={{ margin: "0", fontSize: "30px", textAlign: "left", paddingLeft: "8px", height: "38px" }}
                                                    className="metropolis-bold"
                                                    placeholder="Select City"
                                                />
                                                <p className="text-start px-3">{to3}</p>
                                                {showTo3Dropdown && renderDropdown(to3Options, 'to3', searchQueryTo3, setSearchQueryTo3, inputRefs.to3)}
                                            </div>
                                        </div>
                                        <div className="input-group multiDepartWidth" onClick={() => datePickerRef3.current?.setFocus()}>
                                            <label className="custom-label" htmlFor="depart-3">Depart</label>
                                            <div style={{ border: "1px solid #E0E0E0", height: "70px", borderRadius: "6px" }}>
                                                <DatePicker
                                                    ref={datePickerRef3}
                                                    selected={depart3}
                                                    onChange={date => setDepart3(date)}
                                                    placeholderText="Select Date"
                                                    dateFormat="dd MMM yy"
                                                    className="testDrop metropolis-bold  "
                                                    minDate={depart2 || new Date()}
                                                />
                                                <p style={{ fontSize: "14px", textAlign: "left", paddingLeft: "10px" }}>{depart3 ? depart3.toLocaleDateString('en-US', { weekday: 'long' }) : "Select a date"}</p>
                                            </div>
                                        </div>
                                        <div className="homedeleteButton" onClick={handleRemoveCity}>
                                            <img src="./assets/images/deleteIcon.png" alt="Delete" />
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div style={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
                            <button className="buttonSearchMain" onClick={searchButton}>
                                SEARCH FLIGHTS
                            </button>
                        </div>
                    </div>
                </div>

                {loading && (
                    <div className="loader">
                        <img src="./assets/images/loader.gif" alt="" />
                        <p>Fetching flights for you</p>
                    </div>
                )}
            </div>



        </>
    );
};
export default MainBannerComponent;